import type { IllustrationName } from "../../../illustration";

export type ListEmptyKind = "sem-registros" | "sem-resultados-busca" | "sem-resultados-filtros";
export type ListEmptyGender = "m" | "f";

/** Plurais que não se formam só com "s" (e os mais comuns das listagens): `ListEmptyState` consulta antes do fallback. */
export const PLURAIS_CONHECIDOS: Record<string, string> = {
  obra: "obras",
  embarcação: "embarcações",
  perfil: "perfis",
  papel: "papéis",
  usuário: "usuários",
  profissional: "profissionais",
  registro: "registros",
  fornecedor: "fornecedores",
};

/** `plural` informado vence; depois a tabela de conhecidos; por fim `noun` + "s". */
export function pluralOf(noun: string, plural?: string): string {
  return plural ?? PLURAIS_CONHECIDOS[noun.toLowerCase()] ?? `${noun}s`;
}

export const CLEAR_SEARCH_LABEL = "Limpar Busca";
export const CLEAR_FILTERS_LABEL = "Limpar Filtros";

/**
 * Ilustração de cada situação. O Figma não tem arte própria para "sem registros": usa `sem-dados`, a mais próxima
 * (as telas de hoje mostram um ícone de caixa de entrada).
 */
export const LIST_EMPTY_ILLUSTRATION: Record<ListEmptyKind, IllustrationName> = {
  "sem-registros": "sem-dados",
  "sem-resultados-busca": "sem-resultados",
  "sem-resultados-filtros": "sem-filtros",
};

export interface ListEmptyTexts {
  title: string;
  description: string;
}

/**
 * Textos padrão das listagens. Busca e filtros seguem a família mais frequente nas telas ("… corresponde à busca.");
 * a outra ("… encontrado para essa busca." de usuários e perfis) fica como pendência de padronização.
 */
export function listEmptyTexts(
  kind: ListEmptyKind,
  noun: string,
  gender: ListEmptyGender,
  plural: string,
): ListEmptyTexts {
  const none = gender === "f" ? "Nenhuma" : "Nenhum";

  switch (kind) {
    case "sem-registros":
      return {
        title: `${none} ${noun} cadastrad${gender === "f" ? "a" : "o"}`,
        description: `Assim que houver ${plural} disponíveis, ${gender === "f" ? "elas" : "eles"} aparecerão nesta listagem.`,
      };
    case "sem-resultados-busca":
      return {
        title: `${none} ${noun} corresponde à busca.`,
        description: "Tente revisar o termo pesquisado",
      };
    case "sem-resultados-filtros":
      return {
        title: `${none} ${noun} corresponde aos filtros selecionados.`,
        description: "Tente ajustar ou limpar os filtros",
      };
  }
}
